var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTestImg3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#DDDDDC",
    d: "M52.846 20.413l56.212 12.433-15.54 89.747H51.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M109.058 32.846l39.54 33.024-26.645 83.531-28.435-26.808 9.396-54.267z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A283B8",
    d: "M95.827 109.247H51.696l-.173 13.346h41.995l6.431-1.625zM52.846 20.413l11.572 16.733 42.403 8.619 10.783.83-8.546-13.749z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A283B8",
    d: "M109.058 32.846l40.34 32.732-27.445 83.823-28.435-26.808 2.31-13.346 21.165 20.339 18.681-58.18-28.854-25.641z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#828383",
    d: "M73.229 80.361l8.556.655-.139 1.262-8.563-.656.146-1.261zm1.503-13.007l13.558 1.181-.129 1.264-13.575-1.183.146-1.262zm-.407 3.521l13.621 1.038-.129 1.262-13.637-1.038.145-1.262zm-.366 3.165l8.52.653-.139 1.262-8.527-.654.146-1.261zm-.361 3.13l8.537.654-.139 1.263-8.544-.655.146-1.262zM119.748 72.943l6.387 6.001-.344 1.386-6.397-6.012.354-1.375zm1.832-7.118l-.356 1.382 8.804 8.463.424-1.315-8.872-8.53zm-.919 3.57l-.354 1.378 8.651 8.214.423-1.313-8.72-8.279z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A283B8",
    d: "M63.772 63.15l22.485-7.336.828-.269.421.795 13.113 24.781 11.914-1.951 1.135-.187.088 1.2 1.322 18.039-2.121.165-1.235-16.841-11.512 1.886-.734.12-.361-.681-13.052-24.666-21.658 7.066z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#935D78",
    d: "M79.878 56.184l7.439-5.955 6.201 8.544-9.176 4.662z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#745584",
    d: "M72.837 95.785l-21.314 26.808-21.991-50.507z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B2849A",
    d: "M119.169 94.989l-14.992 4.29 2.35 14.301 13.137-3.302-.495-15.289zm-9.794 12.755l-1.012-5.501 5.624-1.785 1.363 5.504-5.975 1.782z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#935D78",
    d: "M107.487 77.157l8.432-4.401 2.232 10.357-9.175 3.884z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A0A1A0",
    d: "M79.712 94.766l12.895.517-1.24 7.25-12.895-.259z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1216,
    fill: "#070908",
    d: "M109.058 32.846L52.846 20.413l-1.323 102.18h41.995z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M.602 30.903L59.32.599l13.517 95.187-21.652 1.553-5.672 11.451-25.734 12.249z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A283B8",
    d: "M72.837 95.785l-1.805-12.711-43.317 21.258-15.21-65.658L61.31 14.612l-.448-3.151L59.32.599.602 30.903l19.177 90.136z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A283B8",
    d: "M34.436 51.938l17.112 12.396-1.207 1.825-17.112-12.395 1.207-1.826zm32.535 2.541l-12.616 9.708 1.178 1.667L67.3 56.798l-.329-2.319z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D09EB7",
    d: "M50.12 58.543l6.807 3.663-2.572 8.493-8.114-4.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#935D78",
    d: "M27.137 39.871l-6.2 12.688 11.408 8.286 6.944-15.019-12.152-5.955zm3.224 14.759l-4.464-3.106 2.728-5.438 4.712 2.849-2.976 5.695z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#828383",
    d: "M29.057 74.675l11.989-5.894.272 1.269-11.966 5.881-.295-1.256zm1.6 6.804l8.457-4.235.27 1.269-8.431 4.223-.296-1.257zm-.777-3.304l.296 1.259 11.874-5.982-.273-1.271-11.897 5.994z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CDCCCB",
    d: "M40.777 33.139l13.64-6.992.991 7.768-12.895 6.215zM43.504 43.755l7.688-3.366.745 5.437-7.192 3.108z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestImg3);
export default __webpack_public_path__ + "static/media/testImg3.d05000c666461eb76add48be28a3dc2c.svg";
export { ForwardRef as ReactComponent };